var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7318 17.2066L16.4096 18.7354L19.0874 17.2066L30.1403 10.8966L32.8182 9.36772L30.1403 7.83886L19.0874 1.52886L16.4096 0L13.7318 1.52886L2.67783 7.83886L0 9.36772L2.67783 10.8966L5.52646 12.5232L0 15.6777L16.4096 25.0455L21.9361 21.885L19.1723 20.3048L16.4096 21.885L5.52247 15.6728L8.2862 14.0926L13.7318 17.2066ZM8.2043 10.8966L5.52646 9.36772L8.2043 7.83886L16.4096 3.16043L24.6139 7.84479L27.2917 9.37365L24.6139 10.9025L16.4096 15.5859L11.0529 12.5232L16.4096 9.46155L19.0065 10.943L21.7692 9.36279L16.4136 6.30112L8.29019 10.945L8.2043 10.8966Z",
    fill: "#42DB89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/new-logo.55c3551ecb4af3ec156e35aa7f62cae3.svg";
export { ForwardRef as ReactComponent };